import React from "react";
import { useNavigate } from "react-router-dom";

const CheckEmailPage = () => {
  const navigate = useNavigate();

  return (
    <div className="check-email-page bg-gray-100 dark:bg-gray-900 min-h-screen flex flex-col justify-center items-center">
      <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
        Registration Successful!
      </h1>
      <p className="text-gray-700 dark:text-gray-300 mb-4">
        Please check your email to verify your account.
      </p>
      <button
        onClick={() => navigate("/")}
        className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        Go Back to Homepage
      </button>
    </div>
  );
};

export default CheckEmailPage;
